module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/mockup@3x-63dddf739ced18534c609e0a356f88dc.png";